
import { Component, Prop, Vue } from 'vue-property-decorator'
import { IButtons } from '@/shared/types/baseButton'

@Component({ name: 'CustomButtons' })
export default class CustomButtons extends Vue {
  /*  Is an array that passes each of (text, permit, props, icons, onClick and to)*/
  @Prop({ type: Array, required: true }) readonly buttons!: IButtons[]
}
